import React from 'react';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import plusIconTokens from '@amzn/meridian-tokens/base/icon/plus';
import { useHistory } from 'react-router-dom';
import { LocationAddUri } from '$/features/routes';

export const LocationAddButton = (): JSX.Element => {
  const history = useHistory();
  return (
    <Button onClick={() => history.push(LocationAddUri)}>
      <Icon tokens={plusIconTokens} />
      Add New
    </Button>
  );
};
